// src/features/WorkPackage/WorkPackageslice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getWorkPackages,
  addWorkPackage,
  updateWorkPackage,
  deleteWorkPackage,
  getWorkPackagesByUserId,
  getWorkPackageHistoryById,
  getWorkPackageById,
  getWorkPackageByProjectId,
} from "./workPackageApi";

// Thunks
export const fetchWorkPackages = createAsyncThunk(
  "workPackages/fetchWorkPackages",
  async (paramsOptions, thunkAPI) => {
    const response = await getWorkPackages(paramsOptions);
    return { data: response.data, pagination: response.pagination };
  }
);

export const fetchWorkPackageById = createAsyncThunk(
  "projects/fetchWorkPackageById",
  async (_id) => {
    const response = await getWorkPackageById(_id);
    return response.data;
  }
);
export const fetchWorkPackageByProjectId = createAsyncThunk(
  "projects/fetchWorkPackageByProjectId",
  async (projectId) => {
    const response = await getWorkPackageByProjectId(projectId);
    return response.data;
  }
);

export const fetchWorkPackagesByUserId = createAsyncThunk(
  "workPackages/fetchWorkPackagesByUserId",
  async (userId) => {
    const response = await getWorkPackagesByUserId(userId);
    return response.data;
  }
);

export const createWorkPackage = createAsyncThunk(
  "workPackages/createWorkPackage",
  async (formData) => {
    const response = await addWorkPackage(formData);
    return response;
  }
);

export const fetchWorkPackageHistoryById = createAsyncThunk(
  "projects/fetchWorkPackageHistoryById",
  async (paramsOptions) => {
    const response = await getWorkPackageHistoryById(paramsOptions);
    return { data: response.data, pagination: response.pagination };
  }
);

export const updateWorkPackageData = createAsyncThunk(
  "workPackages/updateWorkPackage",
  async (formData) => {
    const response = await updateWorkPackage(formData);
    return response;
  }
);

export const deleteWorkPackageById = createAsyncThunk(
  "workPackages/deleteWorkPackage",
  async (id) => {
    const response = await deleteWorkPackage(id);
    return response;
  }
);

const WorkPackageslice = createSlice({
  name: "workPackages",
  initialState: {
    workPackages: [],
    workPackagesByProjectId: [],
    workPackageById:{},
    workPackageHistory: [],
    wpHistoryPagination: {},
    pagination: {},
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWorkPackages.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchWorkPackages.fulfilled, (state, action) => {
        state.loading = false;
        const { data, pagination } = action.payload || {};
        state.workPackages = data;
        state.pagination = pagination;
      })
       .addCase(fetchWorkPackageById.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchWorkPackageById.fulfilled, (state, action) => {
        state.loading = false;
        state.workPackageById = action.payload;
      })
      .addCase(fetchWorkPackageByProjectId.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchWorkPackageByProjectId.fulfilled, (state, action) => {
        state.loading = false;
        state.workPackagesByProjectId = action.payload;
      })
      .addCase(fetchWorkPackageHistoryById.fulfilled, (state, action) => {
        state.loading = false;
        const { data, pagination } = action.payload || {};
        state.workPackageHistory = data;
        state.wpHistoryPagination = pagination;
      })
      .addCase(createWorkPackage.fulfilled, (state, action) => {
        state.workPackages.push(action.payload.data);
      })
      .addCase(updateWorkPackageData.fulfilled, (state, action) => {
        const idx = state.workPackages.findIndex(
          (u) => u.id === action.payload.id
        );
        if (idx !== -1) {
          state.workPackages[idx] = action.payload.data;
        }
      })
      .addCase(deleteWorkPackageById.fulfilled, (state, action) => {
        state.workPackages = state.workPackages.filter(
          (u) => u.id !== action.payload.id
        );
      });
  },
});

export default WorkPackageslice.reducer;
